import { useTenantConfig } from 'src/utils/hooks/useTenantConfig';
import { mapOrderedFeaturesToLinks } from './types';

export const useSupportLinks = () => {
  const tenantConfig = useTenantConfig();
  const features = tenantConfig?.features;
  const links = mapOrderedFeaturesToLinks(features?.['customizable-support-links']?.orderedFeatures);

  return { supportLinks: links };
};
